export const sortDateDesc = <T>(key: keyof T) => {
  return (a: T, b: T) => {
    const dateA = new Date(a[key] as unknown as string);
    const dateB = new Date(b[key] as unknown as string);
    return dateB.getTime() - dateA.getTime();
  };
};

export const sortDateAsc = <T>(key: keyof T) => {
  return (a: T, b: T) => {
    const dateA = new Date(a[key] as unknown as string);
    const dateB = new Date(b[key] as unknown as string);
    return dateA.getTime() - dateB.getTime();
  };
};

export const sortStringAsc = <T>(key: keyof T) => {
  return (a: T, b: T) => {
    const strA = (a[key] as unknown as string).toLowerCase();
    const strB = (b[key] as unknown as string).toLowerCase();
    return strA.localeCompare(strB);
  };
};

export const sortStringDesc = <T>(key: keyof T) => {
  return (a: T, b: T) => {
    const strA = (a[key] as unknown as string).toLowerCase();
    const strB = (b[key] as unknown as string).toLowerCase();
    return strB.localeCompare(strA);
  };
};

export const sortNumberAsc = <T>(key: keyof T) => {
  return (a: T, b: T) => {
    const numA = a[key] as unknown as number;
    const numB = b[key] as unknown as number;
    return numA - numB;
  };
};

export const sortNumberDesc = <T>(key: keyof T) => {
  return (a: T, b: T) => {
    const numA = a[key] as unknown as number;
    const numB = b[key] as unknown as number;
    return numB - numA;
  };
};
